import { validate as isUUID, v4 as uuid } from 'uuid';

const PLACE_HOLDER_DEVICE_ID = 'PLACE_HOLDER_DEVICE_ID';
export const DEVICE_ID_KEY = 'DeviceId';

/** Sets & gets a UUID deviceId from local storage. This is required by the fincrime team to track if
 *  payments are initiated and executed from the same device. It is consumed by the BE and sent to Feedzai.
 */
export const getDeviceId = () => {
  // TODO:  If were not in a web session we wont have local storage so we need to handle this
  if (typeof window !== 'object') {
    return PLACE_HOLDER_DEVICE_ID;
  }

  let deviceId;
  deviceId = localStorage.getItem(DEVICE_ID_KEY);

  // Check if deviceId exists or is a valid UUID
  if (!deviceId || !isUUID(deviceId)) {
    deviceId = uuid();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};
